"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = exports.StyledCol = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _button = _interopRequireDefault(require("@berlitz/button"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var StyledCol = (0, _styledComponents.default)(_reactStyledFlexboxgrid.Col).withConfig({
  displayName: "Formstyle__StyledCol",
  componentId: "sc-1agg00o-0"
})(["", " margin-bottom:", ";"], function (_ref) {
  var isHidden = _ref.isHidden;
  return isHidden && (0, _styledComponents.css)(["display:none !important;"]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spaceLg;
});
exports.StyledCol = StyledCol;
var SubmitButton = (0, _styledComponents.default)(_button.default).withConfig({
  displayName: "Formstyle__SubmitButton",
  componentId: "sc-1agg00o-1"
})(["margin-top:", ";", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.sm;
}, function (_ref4) {
  var isHidden = _ref4.isHidden;
  return isHidden && (0, _styledComponents.css)(["display:none;"]);
});
exports.SubmitButton = SubmitButton;